import { Component, OnInit, Input, HostBinding } from "@angular/core";
import { ThemePalette } from "@angular/material/core";

@Component({
    selector: "svg-icon",
    templateUrl: "./svg-icon.component.html",
    styleUrls: ["./svg-icon.component.scss"],
    standalone: false
})
export class SvgIconComponent implements OnInit {
	@HostBinding("class") _class = "";
	@HostBinding("style.color") _color: string;
	@HostBinding("style.fill") _fill: string;

	@Input() set color(val: ThemePalette | string) {
		if (val === "primary" || val === "accent" || val === "warn") {
			this._class += `color-${val} `;
		} else {
			this._color = val;
		}
	}

	@Input() set fill(val: ThemePalette | string) {
		if (val === "primary" || val === "accent" || val === "warn") {
			this._class += `fill-${val} `;
		} else {
			this._fill = val;
		}
	}

	src: string;

	@HostBinding("style.width.px")
	public _width: number;

	@Input()
	set width(val: number) {
		this._width = val;
	}

	@HostBinding("style.height.px")
	public _height: number;

	@Input()
	set height(val: number) {
		this._height = val;
	}

	@Input() set size(val: number) {
		this._width = val;
		this._height = val;
	}

	iconFile = "/assets/icons/icons.svg";

	_name: string;
	@Input() set name(val: string) {
		this._name = val;
		this.src = `${this.iconFile}#${this._name}`;
	}

	constructor() {
		this._height = 32;
		this._width = 32;
	}

	ngOnInit() {}
}
